import classNames from 'classnames';
import { Icon, IconProps } from '~/components/Icon/Icon';

export type LevelProps = IconProps;
export const Level = ({ className, ...props }: LevelProps) => (
  <Icon
    className={classNames('level', className)}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.48507 4.11122L2.8244 3.14184L2.83146 2.11908L4.49204 3.08846L4.48507 4.11122ZM3.71653 13.9309L2.75412 13.3691L2.76359 11.9878L1.79999 11.4253L1.85612 3.24364L3.51679 4.21303L3.46521 11.7304L4.42882 12.2929L4.41934 13.6751L5.38169 14.2369L5.37925 14.5956L6.34263 15.1579L6.33566 16.1807L4.67499 15.2113L4.67746 14.8527L3.71405 14.2903L3.71653 13.9309ZM6.60468 16.0306L8.26534 17L8.27231 15.9773L6.61174 15.0079L6.60468 16.0306Z"
      fill="#008FA0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.49181 3.08845L2.83115 2.11907L13.4781 1L15.1388 1.96938L14.6157 2.02436L16.0995 2.89052L15.1315 2.99224L13.6477 2.12611L4.49181 3.08845ZM1.85565 3.24359L3.51632 4.21297L4.48433 4.11126L2.82375 3.14188L1.85565 3.24359Z"
      fill="#00ABBE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1382 1.96942L15.1312 2.99218L16.0992 2.89047L16.0431 11.0721L15.0751 11.1738L15.0611 13.2194L14.0938 13.3211L14.0868 14.3439L13.1187 14.4457L13.1118 15.4685L11.1757 15.672L11.1687 16.6948L8.26458 17L8.27155 15.9772L6.33545 16.1807L6.34251 15.1579L5.37442 15.2596L5.38148 14.2369L4.41421 14.3385L4.42815 12.2929L3.46014 12.3946L3.51628 4.21297L4.48428 4.11125L4.49125 3.08849L15.1382 1.96942Z"
      fill="url(#paint0_linear_833_2198)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5337 4.55164L10.5283 5.33824L11.2728 5.26003L11.262 6.83324L10.5175 6.91152L10.5121 7.69813L9.02251 7.8547L9.02792 7.0681L8.28345 7.14631L8.2942 5.5731L9.03868 5.49481L9.0441 4.70821L10.5337 4.55164Z"
      fill="#F7F7F7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2518 8.32737L11.2464 9.11398L11.9909 9.03576L11.9855 9.82237L12.73 9.74415L12.7192 11.3174L11.9748 11.3956L11.9693 12.1823L7.5017 12.6518L7.50711 11.8652L6.76263 11.9434L6.77339 10.3702L7.51787 10.2919L7.52328 9.50534L8.26783 9.42705L8.27318 8.64045L11.2518 8.32737Z"
      fill="#F7F7F7"
    />
    <defs>
      <linearGradient
        id="paint0_linear_833_2198"
        x1="9.77969"
        y1="-7.93388"
        x2="9.77969"
        y2="17"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#69DEED" />
        <stop offset="1" stopColor="#29D0E2" />
      </linearGradient>
    </defs>
  </Icon>
);
